import { Component } from 'react'
import PropTypes from 'prop-types'
export default class HiddenInput extends Component {
  render() {
    return <input type="hidden" name={this.props.name} value={this.props.value} />
  }
}
HiddenInput.defaultProps = {
  name: null,
  value: null,
}
HiddenInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
